import React, { useEffect, useState } from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import LoaderButton from '../loader-button/LoaderButton';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
import InputUserModal from '../common/InputUserModal';
// services
import BZAPIService from '../../services/BZAPIService';
//libs
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// constants

const ViewUsers = () => {
  const [userList, setUserList] = useState([]);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [userRbacRoles, setUserRbacRoles] = useState([]);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const usersPromise = BZAPIService.listUsers();
        const myUserPermissionsPromise = BZAPIService.getMyUserPermissions();
        const [users, myUserPermissions] = await Promise.all([usersPromise, myUserPermissionsPromise]);
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));
        setIsLoading(false);

        setUserList(users ? users : []);
      } catch (e) {
        setIsLoading(false);
      }
    }
    onLoad();
  }, []);
  const handleEditUser = async user => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      setSelectedUser(user);
      // Edit User
      const apiRbacRolesPromise = BZAPIService.getRbacRoles() || {};
      const apiUserRbacRolesPromise = BZAPIService.getUserRbacRoles(user.Username) || {};
      const [apiRbacRoles, apiUserRbacRoles] = await Promise.all([apiRbacRolesPromise, apiUserRbacRolesPromise]);
      setRoles(apiRbacRoles);
      setUserRbacRoles(apiUserRbacRoles);
      setModalOpen(true);
      setLoader(false);
    } catch (e) {
      setLoader(false);
      toast.error('Failed to load role');
    }
  };
  const updateUser = async payload => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API User
      await BZAPIService.updateUser(selectedUser.Username, payload);
      toast.success('User updated');
      setLoader(false);
      setModalOpen(false);
    } catch (e) {
      setLoader(false);
      toast.error('Failed to update role');
    }
  };

  if (isLoading && !isSubmitted) return <Loader text="Loading users..." />;
  return (
    <>
      <Heading title="BugZero users" subtitle="View users within your organization" className="mb-4 mt-3" icon="user" />

      <Card>
        <CardBody className="fs--1">
          <div className="row">
            <div className="col text-right">
              <a
                href={`/documentation/user-guides/rbac-guide`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-falcon-default ml-2 btn-sm"
                data-testid={'integration-link'}
              >
                <FontAwesomeIcon icon="book" className="mr-2" />
                BugZero RBAC guide
              </a>
            </div>
          </div>
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Email</th>
                <th>Last Modified</th>
                <th>Created</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {userList?.length ? (
                userList.map(user => {
                  // Email
                  const { Username: userId, Attributes, UserLastModifiedDate, UserCreateDate } = user;
                  const email = Attributes.find(item => item.Name === 'email').Value;
                  return (
                    <tr key={userId} id={userId} className="font-weight-bold" data-testid={'user-row'}>
                      <td>
                        <div className="py-2">{email}</div>
                      </td>
                      <td>
                        <div className="py-2">{UserLastModifiedDate}</div>
                      </td>
                      <td>
                        <div className="py-2">{UserCreateDate}</div>
                      </td>
                      <td>
                        <>
                          <LoaderButton
                            isLoading={selectedUser?.Username === userId && loader}
                            onClick={e => handleEditUser(user)}
                            value={userId}
                            name={user.name}
                            color="falcon-primary"
                            block
                            size="sm"
                            data-testid={'user-delete-alert'}
                          >
                            <FontAwesomeIcon icon={'edit'} value={userId} />
                          </LoaderButton>
                        </>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>You have no users yet</td>
                  <td />
                  <td />
                  <td />
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
        </CardBody>
      </Card>
      {!!selectedUser && (
        <InputUserModal
          isReadOnly={isReadOnly}
          selectedUser={selectedUser}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          modalOpen={modalOpen}
          roles={roles}
          setModalOpen={setModalOpen}
          setIsLoading={setIsLoading}
          userRbacRoles={userRbacRoles}
          updateUser={updateUser}
          loader={loader}
        />
      )}
    </>
  );
};

export default ViewUsers;
